import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "next/navigation";

import getStrainLists, {
  getStrainListsReturn,
  ITEMS_PER_STRAIN_PAGE,
} from "@/api/requests/getStrainLists";
import { useSelector } from "@/redux/hooks";
import { getCoordinates } from "@/redux/selectors/location";

import { useFilterQueryParams } from "@/components/MenuFilters/v2/hooks";

const useGetStrainLists = (initialData: getStrainListsReturn) => {
  const searchParams = useSearchParams();
  const params = useParams();
  const slug = params?.slug;
  const page = searchParams?.get("page") || "1";
  const sort = searchParams?.get("sort");
  const [data, setData] = useState({
    ...initialData.metadata,
    strains: initialData.strains,
  });
  const [loading, setLoading] = useState(true);

  const coordinates = useSelector(getCoordinates);

  const pageCategory = slug?.[0];
  const pageName = pageCategory && slug?.[1];

  const { appliedFilters: filterValues } = useFilterQueryParams();

  const isMounted = useRef(false);
  useEffect(() => {
    if (isMounted.current) {
      const fetchStrainLists = async () => {
        setLoading(true);

        const {
          metadata: { availableFilters, availableSorts, totalCount },
          strains,
        } = await getStrainLists(
          { ...filterValues },
          (Number(typeof page === "string" ? page : "1") - 1) *
            ITEMS_PER_STRAIN_PAGE,
          ITEMS_PER_STRAIN_PAGE,
          coordinates,
          typeof sort === "string" ? sort : undefined,
          undefined,
          pageCategory,
          pageName,
        );

        setData({
          availableFilters,
          availableSorts,
          strains,
          totalCount,
        });
        setLoading(false);
      };

      fetchStrainLists();
    } else {
      if (initialData) {
        setLoading(false);
      }
      isMounted.current = true;
    }
  }, [JSON.stringify(filterValues), page, pageCategory, pageName, sort]);

  return {
    data,
    loading,
  };
};

export default useGetStrainLists;
